import React from "react"
import Button from "../../button/Button"
import ProductFooter from "../footer/ProductFooter"
import { graphql } from "gatsby"
import { IFeatureProps } from "../gridLayout1/OneLargeTwoSmall"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const SmallFeature: React.FC<IFeatureProps> = ({
  backgroundImage,
  icon,
  button,
  description,
  footer,
}) => {
  const gatsbyImageIcon = icon && getImage(icon.gatsbyImage)
  const gatsbyImageBg = backgroundImage && getImage(backgroundImage.gatsbyImage)

  return (
    <div className="relative flex min-h-[249px] flex-col justify-end  justify-between bg-cover bg-bottom bg-no-repeat text-white">
      <div className="absolute top-0 left-0 h-full w-full">
        {gatsbyImageBg && (
          <GatsbyImage
            image={gatsbyImageBg}
            alt={backgroundImage.altText}
            className="absolute top-0 left-0 h-full w-full object-cover object-bottom"
          />
        )}
        <div className="absolute left-0 top-0 h-full w-full rounded bg-[linear-gradient(270deg,#000000_0%,#00000000_72.98%)] " />
        <div className="absolute left-0 top-0 h-full w-full rounded bg-darkBlue bg-opacity-40 " />
      </div>
      <div className="relative z-10 mt-[29px] mb-auto flex flex-col items-end px-[20px]">
        {gatsbyImageIcon && (
          <GatsbyImage
            image={gatsbyImageIcon}
            className="left-[15px]"
            alt={icon.altText}
          />
        )}

        <p className="mt-0.5 max-w-[307px] text-body1">{description}</p>
        {button?.title && (
          <Button to={button?.url} className="mt-7 px-[30px] py-1">
            {button.title}
          </Button>
        )}
      </div>
      {footer?.headline && <ProductFooter {...footer} />}
    </div>
  )
}

export default SmallFeature

export const fragment = graphql`
  fragment SmallFeature on WpDefaultTemplate_Acf_Modules_Promos_Promos_GridLayout1 {
    fieldGroupName
    smallTileSmallblocks {
      ... on WpDefaultTemplate_Acf_Modules_Promos_Promos_GridLayout1_SmallTileSmallblocks_Feature {
        button {
          target
          title
          url
        }
        description
        fieldGroupName
        icon {
          altText
          gatsbyImage(
            placeholder: BLURRED
            quality: 100
            width: 176
            height: 48
            layout: CONSTRAINED
            formats: [AUTO, WEBP]
          )
        }
        backgroundImage {
          altText
          gatsbyImage(
            quality: 85
            layout: FULL_WIDTH
            width: 500
            height: 250
            formats: [AUTO, WEBP]
          )
        }
        footer {
          headline
          link {
            target
            title
            url
          }
        }
      }
    }
  }
`
